import {
  GetButtonLabel,
  SelectPlanCTAText,
} from '../../../../../../../../../shared/design-system/components/molecules/pricing-card/types';
import { Images } from '../../../../../../../../../shared/app-constants';
import { BillingOption } from '../../../../../../../../../shared/utils/billing-options';
import { SubscriptionPlanTitle } from '../../../../../../../../../shared/utils/subscription-plans';
import { GetPlansResponse } from '../../../../../types';
import { isCustomScalePlusPlan } from '../../plans-section/utils/helper';
import { checkIsDemoPlanUser } from '../../../../../../../../../shared/design-system/components/molecules/subscription-plan-details/helper/helper';
import { OldPlanId } from '../../../../../../../../../shared/enums/old-pan-id';

const outreachBasicMonthlyFeatures = [
  {
    label: 'Unlimited Prospects',
    tooltipText:
      "You'll be able to import unlimited prospects. Subject to Fair Usage Policy.",
    labelClass: 'font-semibold',
    highlight: true,
  },
  {
    label: 'Unlimited Email Accounts',
    labelClass: 'font-semibold',
    highlight: true,
  },
  {
    label: 'Unlimited Email Warm up',
    tooltipText:
      'Email Warm-up is provided by our partner TrulyInbox. Sending is Subject to Fair Usage Policy',
  },
  {
    label: 'Sender Rotation Basic',
    tooltipText: '10 email accounts allowed per sequence',
  },
  {
    label: 'Unified Inbox',
    tooltipText:
      'Full access to all the conversations with no restrictions on actions',
  },
  {
    label: '2,000 Active Prospects',
    tooltipText:
      'Total number of prospects allowed in active Saleshandy sequences for outreach at once.',
  },
  {
    label: '6,000 Emails Per Month',
    tooltipText:
      'Total number of emails you can send in a month across your saleshandy account',
  },
  {
    label: '100 AI Credits',
  },
  {
    label: '1,000 Email Verification Credits',
  },
  {
    label: '50 Free Lead Finder Credits',
    tooltipText:
      'These credits are available for first-time purchases and you can reveal Email and Phone numbers both.',
  },
];
const outreachBasicQuarterlyFeatures = [
  {
    label: 'Unlimited Prospects',
    tooltipText:
      "You'll be able to import unlimited prospects. Subject to Fair Usage Policy.",
    labelClass: 'font-semibold',
    highlight: true,
  },
  {
    label: 'Unlimited Email Accounts',
    labelClass: 'font-semibold',
    highlight: true,
  },
  {
    label: 'Unlimited Email Warm up',
    tooltipText:
      'Email Warm-up is provided by our partner TrulyInbox. Sending is Subject to Fair Usage Policy',
  },
  {
    label: 'Sender Rotation Basic',
    tooltipText: '10 email accounts allowed per sequence',
  },
  {
    label: 'Unified Inbox',
    tooltipText:
      'Full access to all the conversations with no restrictions on actions',
  },
  {
    label: '2,000 Active Prospects',
    tooltipText:
      'Total number of prospects allowed in active Saleshandy sequences for outreach at once.',
  },
  {
    label: '6,000 Emails Per Month',
    tooltipText:
      'Total number of emails you can send in a month across your saleshandy account',
  },
  {
    label: '100 AI Credits',
  },
  {
    label: '1,000 Email Verification Credits',
  },
  {
    label: '50 Free Lead Finder Credits',
    tooltipText:
      'These credits are available for first-time purchases and you can reveal Email and Phone numbers both.',
  },
];
const outreachBasicYearlyFeatures = [
  {
    label: 'Unlimited Prospects',
    tooltipText:
      "You'll be able to import unlimited prospects. Subject to Fair Usage Policy.",
    labelClass: 'font-semibold',
    highlight: true,
  },
  {
    label: 'Unlimited Email Accounts',
    labelClass: 'font-semibold',
    highlight: true,
  },
  {
    label: 'Unlimited Email Warm up',
    tooltipText:
      'Email Warm-up is provided by our partner TrulyInbox. Sending is Subject to Fair Usage Policy',
  },
  {
    label: 'Sender Rotation Basic',
    tooltipText: '10 email accounts allowed per sequence',
  },
  {
    label: 'Unified Inbox',
    tooltipText:
      'Full access to all the conversations with no restrictions on actions',
  },
  {
    label: '2,000 Active Prospects',
    tooltipText:
      'Total number of prospects allowed in active Saleshandy sequences for outreach at once.',
  },
  {
    label: '6,000 Emails Per Month',
    tooltipText:
      'Total number of emails you can send in a month across your Saleshandy account',
  },
  {
    label: '100 AI Credits',
  },
  {
    label: '1,000 Email Verification Credits',
  },
  {
    label: '50 Free Lead Finder Credits',
    tooltipText:
      'These credits are available for first-time purchases and you can reveal Email and Phone numbers both.',
  },
];

const outreachProMonthlyFeatures = [
  {
    label: 'Unlimited Prospects',
    tooltipText:
      "You'll be able to import unlimited prospects. Subject to Fair Usage Policy.",
    labelClass: 'font-semibold',
    highlight: true,
  },
  {
    label: 'Everything in Outreach Starter',
    labelClass: 'font-semibold',
    highlight: true,
  },
  {
    label: 'Unlimited Team Members',
    labelClass: 'font-semibold',
  },
  {
    label: 'Sender Rotation Pro',
    tooltipText: '100 email accounts allowed per sequence',
  },
  {
    label: 'Subsequence',
    tooltipText: 'Send targeted follow-ups with conditions.',
  },
  {
    label: 'AI Variants',
    tooltipText:
      'You will be able to generate unlimited AI variants. Subject to fair usage policy.',
  },
  {
    label: 'Unlimited Email Warm up',
    tooltipText:
      'Email Warm-up is provided by our partner TrulyInbox. Sending is Subject to Fair Usage Policy',
  },
  {
    label: '30,000 Active Prospects',
    tooltipText:
      'Total number of prospects allowed in active Saleshandy sequences for outreach at once.',
  },
  {
    label: '150,000 Emails Per Month',
    tooltipText:
      'Total number of emails you can send in a month across your saleshandy account',
  },
  {
    label: '200 AI Credits',
  },
  {
    label: '5,000 Email Verification Credits',
  },
  {
    label: '1 Inbox Placement Test',
    tooltipText:
      'Checks where your emails land (Inbox, Spam or Other tabs) across major email providers.',
  },
  {
    label: '100 Free Lead Finder Credits',
    tooltipText:
      'These credits are available for first-time purchases and you can reveal Email and Phone numbers both.',
  },
];
const outreachProQuartelyFeatures = [
  {
    label: 'Unlimited Prospects',
    tooltipText:
      "You'll be able to import unlimited prospects. Subject to Fair Usage Policy.",
    labelClass: 'font-semibold',
    highlight: true,
  },
  {
    label: 'Everything in Outreach Starter',
    labelClass: 'font-semibold',
    highlight: true,
  },
  {
    label: 'Unlimited Team Members',
    labelClass: 'font-semibold',
  },
  {
    label: 'Sender Rotation Pro',
    tooltipText: '100 email accounts allowed per sequence',
  },
  {
    label: 'Subsequence',
    tooltipText: 'Send targeted follow-ups with conditions.',
  },
  {
    label: 'AI Variants',
    tooltipText:
      'You will be able to generate unlimited AI variants. Subject to fair usage policy.',
  },
  {
    label: 'Unlimited Email Warm up',
    tooltipText:
      'Email Warm-up is provided by our partner TrulyInbox. Sending is Subject to Fair Usage Policy',
  },
  {
    label: '30,000 Active Prospects',
    tooltipText:
      'Total number of prospects allowed in active Saleshandy sequences for outreach at once.',
  },
  {
    label: '150,000 Emails Per Month',
    tooltipText:
      'Total number of emails you can send in a month across your saleshandy account',
  },
  {
    label: '200 AI Credits',
  },
  {
    label: '5,000 Email Verification Credits',
  },
  {
    label: '1 Inbox Placement Test',
    tooltipText:
      'Checks where your emails land (Inbox, Spam or Other tabs) across major email providers.',
  },
  {
    label: '100 Free Lead Finder Credits',
    tooltipText:
      'These credits are available for first-time purchases and you can reveal Email and Phone numbers both.',
  },
];
const outreachProYearlyFeatures = [
  {
    label: 'Unlimited Prospects',
    tooltipText:
      "You'll be able to import unlimited prospects. Subject to Fair Usage Policy.",
    labelClass: 'font-semibold',
    highlight: true,
  },
  {
    label: 'Everything in Outreach Starter',
    labelClass: 'font-semibold',
    highlight: true,
  },
  {
    label: 'Unlimited Team Members',
    labelClass: 'font-semibold',
  },
  {
    label: 'Sender Rotation Pro',
    tooltipText: '100 email accounts allowed per sequence',
  },
  {
    label: 'Subsequence',
    tooltipText: 'Send targeted follow-ups with conditions.',
  },
  {
    label: 'AI Variants',
    tooltipText:
      'You will be able to generate unlimited AI variants. Subject to fair usage policy.',
  },
  {
    label: 'Unlimited Email Warm up',
    tooltipText:
      'Email Warm-up is provided by our partner TrulyInbox. Sending is Subject to Fair Usage Policy',
  },
  {
    label: '30,000 Active Prospects',
    tooltipText:
      'Total number of prospects allowed in active Saleshandy sequences for outreach at once.',
  },
  {
    label: '150,000 Emails Per Month',
    tooltipText:
      'Total number of emails you can send in a month across your Saleshandy account',
  },
  {
    label: '200 AI Credits',
  },
  {
    label: '5,000 Email Verification Credits',
  },
  {
    label: '1 Inbox Placement Test',
    tooltipText:
      'Checks where your emails land (Inbox, Spam or Other tabs) across major email providers.',
  },
  {
    label: '100 Free Lead Finder Credits',
    tooltipText:
      'These credits are available for first-time purchases and you can reveal Email and Phone numbers both.',
  },
];

const outreachScaleMonthlyFeatures = [
  {
    label: 'Unlimited Prospects',
    tooltipText:
      "You'll be able to import unlimited prospects. Subject to Fair Usage Policy.",
    labelClass: 'font-semibold',
    highlight: true,
  },
  {
    label: 'Everything in Outreach Pro',
    labelClass: 'font-semibold',
    highlight: true,
  },
  {
    label: 'Sender Rotation Scale',
    tooltipText: '1000 email accounts allowed per sequence',
  },
  {
    label: 'Unlimited Email Warm up',
    tooltipText:
      'Email Warm-up is provided by our partner TrulyInbox. Sending is Subject to Fair Usage Policy',
  },
  {
    label: '60,000 Active Prospects',
    tooltipText:
      'Total number of prospects allowed in active Saleshandy sequences for outreach at once.',
  },
  {
    label: '240,000 Emails per Month',
    tooltipText:
      'Total number of emails you can send in a month across your Saleshandy account',
  },
  {
    label: '500 AI Credits',
  },
  {
    label: '10,000 Email Verification Credits',
  },
  {
    label: 'Priority Support',
  },
  {
    label: 'Agency Whitelabel',
  },
  {
    label: '100 Free Lead Finder Credits',
    tooltipText:
      'These credits are available for first-time purchases and you can reveal Email and Phone numbers both.',
  },
  {
    label: 'Single Sign-on (SSO)',
  },
  {
    label: '2 Inbox Placement Test',
    tooltipText:
      'Checks where your emails land (Inbox, Spam or Other tabs) across major email providers.',
  },
];
const outreachScaleQuartelyFeatures = [
  {
    label: 'Unlimited Prospects',
    tooltipText:
      "You'll be able to import unlimited prospects. Subject to Fair Usage Policy.",
    labelClass: 'font-semibold',
    highlight: true,
  },
  {
    label: 'Everything in Outreach Pro',
    labelClass: 'font-semibold',
    highlight: true,
  },
  {
    label: 'Sender Rotation Scale',
    tooltipText: '1000 email accounts allowed per sequence',
  },
  {
    label: 'Unlimited Email Warm up',
    tooltipText:
      'Email Warm-up is provided by our partner TrulyInbox. Sending is Subject to Fair Usage Policy',
  },
  {
    label: '60,000 Active Prospects',
    tooltipText:
      'Total number of prospects allowed in active Saleshandy sequences for outreach at once.',
  },
  {
    label: '240,000 Emails per Month',
    tooltipText:
      'Total number of emails you can send in a month across your Saleshandy account',
  },
  {
    label: '500 AI Credits',
  },
  {
    label: '10,000 Email Verification Credits',
  },
  {
    label: 'Priority Support',
  },
  {
    label: 'Agency Whitelabel',
  },
  {
    label: '100 Free Lead Finder Credits',
    tooltipText:
      'These credits are available for first-time purchases and you can reveal Email and Phone numbers both.',
  },
  {
    label: 'Single Sign-on (SSO)',
  },
  {
    label: '2 Inbox Placement Test',
    tooltipText:
      'Checks where your emails land (Inbox, Spam or Other tabs) across major email providers.',
  },
];
const outreachScaleYearlyFeatures = [
  {
    label: 'Unlimited Prospects',
    tooltipText:
      "You'll be able to import unlimited prospects. Subject to Fair Usage Policy.",
    labelClass: 'font-semibold',
    highlight: true,
  },
  {
    label: 'Everything in Outreach Pro',
    labelClass: 'font-semibold',
    highlight: true,
  },
  {
    label: 'Sender Rotation Scale',
    tooltipText: '1000 email accounts allowed per sequence',
  },
  {
    label: 'Unlimited Email Warm up',
    tooltipText:
      'Email Warm-up is provided by our partner TrulyInbox. Sending is Subject to Fair Usage Policy',
  },
  {
    label: '60,000 Active Prospects',
    tooltipText:
      'Total number of prospects allowed in active Saleshandy sequences for outreach at once.',
  },
  {
    label: '240,000 Emails Per Month',
    tooltipText:
      'Total number of emails you can send in a month across your Saleshandy account',
  },
  {
    label: '500 AI Credits',
  },
  {
    label: '10,000 Email Verification Credits',
  },
  {
    label: 'Priority Support',
  },
  {
    label: 'Agency Whitelabel',
  },
  {
    label: '100 Free Lead Finder Credits',
    tooltipText:
      'These credits are available for first-time purchases and you can reveal Email and Phone numbers both.',
  },
  {
    label: 'Single Sign-on (SSO)',
  },
  {
    label: '2 Inbox Placement Test',
    tooltipText:
      'Checks where your emails land (Inbox, Spam or Other tabs) across major email providers.',
  },
];

const customScaleFeatures = [
  {
    label: 'Unlimited Prospects',
    tooltipText:
      "You'll be able to import unlimited prospects. Subject to Fair Usage Policy.",
    labelClass: 'font-semibold',
    highlight: true,
  },
  {
    label: 'Everything in Outreach Scale',
    labelClass: 'font-semibold',
    highlight: true,
  },
  {
    label: 'Dedicated Success Manager',
    tooltipText: 'A dedicated success manager to handle your account',
  },
];

const customPlanFeatures = [
  ...customScaleFeatures,
  {
    label: 'Unlimited Email Warm up',
    tooltipText:
      'Email Warm-up is provided by our partner TrulyInbox. Sending is Subject to Fair Usage Policy',
  },
  {
    label: 'Custom Prospects Limit',
  },
  {
    label: 'Custom Emails Sending Limit',
  },
  {
    label: 'Custom Email Verification Credits',
  },
  {
    label: 'Single Sign-on (SSO)',
  },
  {
    label: '2 Inbox Placement Test',
    tooltipText:
      'Checks where your emails land (Inbox, Spam or Other tabs) across major email providers.',
  },
];

export const customScalePlusFeatures = (
  getProspectsRangeValue,
  getEmailsRangeValue,
) => [
  {
    label: 'Unlimited Prospects',
    tooltipText:
      "You'll be able to import unlimited prospects. Subject to Fair Usage Policy.",
    labelClass: 'font-semibold',
    highlight: true,
  },
  {
    label: 'Everything in Outreach Scale',
    labelClass: 'font-semibold',
    highlight: true,
  },
  {
    label: 'Dedicated Success Manager',
    tooltipText: 'A dedicated success manager to handle your account',
  },
  {
    label: 'Unlimited Email Warm up',
    tooltipText:
      'Email Warm-up is provided by our partner TrulyInbox. Sending is Subject to Fair Usage Policy',
  },
  {
    label: `${getProspectsRangeValue?.toLocaleString()} Active Prospects`,
    tooltipText:
      'Total number of prospects allowed in active Saleshandy sequences for outreach at once.',
  },
  {
    label: `${getEmailsRangeValue?.toLocaleString()} Emails Per Month`,
    tooltipText:
      'Total number of emails you can send in a month across your Saleshandy account',
  },
  {
    label: '500 AI Credits',
  },
  {
    label: '10,000 Email Verification Credits',
  },
  {
    label: '100 Free Lead Finder Credits',
    tooltipText:
      'These credits are available for first-time purchases and you can reveal Email and Phone numbers both.',
  },
  {
    label: 'Single Sign-on (SSO)',
  },
  {
    label: '2 Inbox Placement Test',
    tooltipText:
      'Checks where your emails land (Inbox, Spam or Other tabs) across major email providers.',
  },
];

export const customPlanFeature = [
  {
    label: 'Unlimited Prospects',
    tooltipText:
      "You'll be able to import unlimited prospects. Subject to Fair Usage Policy.",
    labelClass: 'font-semibold',
    highlight: true,
  },
  {
    label: 'Everything in Outreach Scale',
    labelClass: 'font-semibold',
    highlight: true,
  },
  {
    label: 'Dedicated Success Manager',
    tooltipText: 'A dedicated success manager to handle your account',
  },
  {
    label: 'Unlimited Email Warm-up',
    tooltipText:
      'Email Warm-up is provided by our partner TrulyInbox. Sending is Subject to Fair Usage Policy',
  },
  {
    label: 'Custom Prospects Limit',
  },
  {
    label: 'Custom Emails Sending Limit',
  },
  {
    label: 'Custom Email Verification Credits',
  },
  {
    label: 'Single Sign-on (SSO)',
  },
  {
    label: 'Custom Inbox Placement Test',
  },
];

const planMetaData = {
  [SubscriptionPlanTitle.OutreachBasicMonthly]: {
    displayName: 'Starter',
    features: outreachBasicMonthlyFeatures,
  },
  [SubscriptionPlanTitle.OutreachProMonthly]: {
    displayName: 'Pro',
    features: outreachProMonthlyFeatures,
    isBestValuePlan: true,
  },
  [SubscriptionPlanTitle.OutreachScaleMonthly]: {
    displayName: 'Scale',
    features: outreachScaleMonthlyFeatures,
  },
  [SubscriptionPlanTitle.OutreachBasicQuarterly]: {
    displayName: 'Starter',
    features: outreachBasicQuarterlyFeatures,
  },
  [SubscriptionPlanTitle.OutreachProQuarterly]: {
    displayName: 'Pro',
    features: outreachProQuartelyFeatures,
    isBestValuePlan: true,
  },
  [SubscriptionPlanTitle.OutreachScaleQuarterly]: {
    displayName: 'Scale',
    features: outreachScaleQuartelyFeatures,
  },
  [SubscriptionPlanTitle.OutreachBasicYearly]: {
    displayName: 'Starter',
    features: outreachBasicYearlyFeatures,
  },
  [SubscriptionPlanTitle.OutreachProYearly]: {
    displayName: 'Pro',
    features: outreachProYearlyFeatures,
    isBestValuePlan: true,
  },
  [SubscriptionPlanTitle.OutreachScaleYearly]: {
    displayName: 'Scale',
    features: outreachScaleYearlyFeatures,
  },
  [SubscriptionPlanTitle.OutreachScaleMonthlyBase]: {
    displayName: 'Scale Plus',
    features: outreachScaleYearlyFeatures,
  },
  [SubscriptionPlanTitle.OutreachScaleQuarterlyBase]: {
    displayName: 'Scale Plus',
    features: outreachScaleYearlyFeatures,
  },
  [SubscriptionPlanTitle.OutreachScaleYearlyBase]: {
    displayName: 'Scale Plus',
    features: outreachScaleYearlyFeatures,
  },
  [SubscriptionPlanTitle.Custom]: {
    displayName: SubscriptionPlanTitle.Custom,
    features: customPlanFeatures,
  },
};

export const getOutreachPlanMetaData = (planName) => planMetaData[planName];

export const getPlanPrice = (planPrice, planMode) =>
  Number(planPrice) / Number(planMode);

const extractPlanCode = (
  planCode: string,
): 'basic' | 'pro' | 'scale' | null => {
  if (planCode?.includes('basic')) return 'basic';
  if (planCode?.includes('pro')) return 'pro';
  if (planCode?.includes('scale')) return 'scale';
  return null;
};

const planCodeHierarchy = ['basic', 'pro', 'scale'];

export const getButtonLabel = ({
  plan,
  sendGetAccountSubscriptionResponse,
  planCycle,
  prospectCountInputValue,
  emailCountInputValue,
}: GetButtonLabel) => {
  if (checkIsDemoPlanUser()) {
    return SelectPlanCTAText.UpgradePlan;
  }

  const {
    planMode,
    planId: subscriptionId,
    planCode,
  } = sendGetAccountSubscriptionResponse;

  const isCurrentPlanCustom = isCustomScalePlusPlan(subscriptionId);
  const isSelectedPlanCustom = isCustomScalePlusPlan(plan?.id);

  if (isCurrentPlanCustom && !isSelectedPlanCustom) {
    return SelectPlanCTAText.DowngradePlan;
  }

  if (!isCustomScalePlusPlan(plan?.id)) {
    const currentPlan = extractPlanCode(planCode);
    const selectedPlan = extractPlanCode(plan?.planCode || '');

    const currentIndex = planCodeHierarchy?.indexOf(currentPlan || '');
    const selectedIndex = planCodeHierarchy?.indexOf(selectedPlan || '');

    if (currentPlan === selectedPlan) {
      // First check if the current plan is an old plan
      if (
        subscriptionId &&
        Object.values(OldPlanId).includes(Number(subscriptionId)) &&
        ((planMode === 1 && planCycle === BillingOption.MONTHLY) ||
          (planMode === 3 && planCycle === BillingOption.QUARTERLY) ||
          (planMode === 12 && planCycle === BillingOption.ANNUALLY))
      ) {
        return SelectPlanCTAText.UpdatePlan;
      }

      // for monthly plan
      if (planMode === 1) {
        if (planCycle === BillingOption.MONTHLY) {
          return SelectPlanCTAText.CurrentPlan;
        }

        if (
          planCycle === BillingOption.QUARTERLY ||
          planCycle === BillingOption.ANNUALLY
        ) {
          return SelectPlanCTAText.UpgradePlan;
        }
      }
      // for quarterly plan
      if (planMode === 3) {
        if (planCycle === BillingOption.QUARTERLY) {
          return SelectPlanCTAText.CurrentPlan;
        }

        if (planCycle === BillingOption.ANNUALLY) {
          return SelectPlanCTAText.UpgradePlan;
        }

        if (planCycle === BillingOption.MONTHLY) {
          return SelectPlanCTAText.DowngradePlan;
        }
      }
      // for yearly plan
      if (planMode === 12) {
        if (planCycle === BillingOption.ANNUALLY) {
          return SelectPlanCTAText.CurrentPlan;
        }

        if (
          planCycle === BillingOption.MONTHLY ||
          planCycle === BillingOption.QUARTERLY
        ) {
          return SelectPlanCTAText.DowngradePlan;
        }
      }

      return SelectPlanCTAText.CurrentPlan;
    }

    if (selectedIndex < currentIndex) {
      return SelectPlanCTAText.DowngradePlan;
    }

    if (selectedIndex > currentIndex) {
      return SelectPlanCTAText.UpgradePlan;
    }
  }

  if (isCustomScalePlusPlan(plan?.id)) {
    const {
      activeProspectLimit,
      emailSendLimit,
      parentId,
    } = sendGetAccountSubscriptionResponse;

    const isMatchingPlanCycleMode =
      (planCycle === BillingOption.MONTHLY && planMode === 1) ||
      (planCycle === BillingOption.QUARTERLY && planMode === 3) ||
      (planCycle === BillingOption.ANNUALLY && planMode === 12);

    if (isMatchingPlanCycleMode) {
      const isUpgrade =
        activeProspectLimit < prospectCountInputValue ||
        emailSendLimit < emailCountInputValue;
      const isDowngrade =
        activeProspectLimit > prospectCountInputValue ||
        emailSendLimit > emailCountInputValue;

      if (isUpgrade || plan?.id < parentId) {
        return SelectPlanCTAText.UpgradePlan;
      }

      if (isDowngrade) {
        return SelectPlanCTAText.DowngradePlan;
      }

      if (plan?.id > parentId) {
        if (isDowngrade) {
          return SelectPlanCTAText.DowngradePlan;
        }
      }

      if (parentId === plan?.id) {
        return SelectPlanCTAText.CurrentPlan;
      }
    }
  }

  if (subscriptionId) {
    if (subscriptionId === plan.id) {
      return SelectPlanCTAText.CurrentPlan;
    }
  }

  return SelectPlanCTAText.UpgradePlan;
};

export const getPlanDetailsObj = (plan, isUserSubscribed) => ({
  id: plan?.id || null,
  planName: plan?.planName,
  displayName: getOutreachPlanMetaData(plan?.planName)?.displayName,
  isBestValuePlan: getOutreachPlanMetaData(plan?.planName)?.isBestValuePlan,
  features: isUserSubscribed
    ? getOutreachPlanMetaData(plan?.planName)?.features?.filter(
        (feature) => !feature?.label?.includes('Free Lead Finder Credits'),
      )
    : getOutreachPlanMetaData(plan?.planName)?.features,
  price: getPlanPrice(plan?.amount, plan?.planMode) || null,
  ...plan,
});

// export const getMonthlyPrice = (planName, allPlans) =>
//   parseInt(
//     allPlans.find(
//       (plan) =>
//         plan.planName === `${planName} (Monthly)` && plan.planMode === 1,
//     )?.amount,
//     10,
//   );

export const getMonthlyPrice = (planName, allPlans) => {
  const plan = allPlans?.find(
    (plans) =>
      plans?.planName?.includes(planName) &&
      plans?.planName?.includes('(Monthly)') &&
      plans?.planMode === 1,
  );

  return plan && parseInt(plan.amount, 10); // Return 0 if no match is found
};
export const getQuarterlyPrice = (planName, allPlans) => {
  const plan = allPlans?.find(
    (plans) =>
      plans?.planName?.includes(planName) &&
      plans?.planName?.includes('(Quarterly)') &&
      plans?.planMode === 3,
  );

  return plan && parseInt(plan.amount, 10); // Return 0 if no match is found
};
export const getEmailOutreachPlanYearlyPrice = (
  planCode: string,
  plans: GetPlansResponse,
) => {
  const correspondingYearlyPlanCode =
    planCode?.replace('monthly', 'yearly') || '';

  const correspondingYearlyPlan = plans.find(
    (plan) => plan.planCode === correspondingYearlyPlanCode,
  );

  if (correspondingYearlyPlan) {
    return parseInt(correspondingYearlyPlan?.amount || '0', 10);
  }

  return 0;
};

export const getInitialStepValue = (planId, planMode) => {
  const planIdWiseStep = {
    97: 1,
    98: 2,
    99: 3,
    100: 4,
    101: 5,
  };

  if (planMode === 12 && planId >= 97) {
    return planIdWiseStep[planId];
  }

  return 1;
};

export const getCustomScalePlusDiscountPer = (step) => {
  const stepWiseDiscount = {
    step1: '27',
    step2: '30',
    step3: '31',
    step4: '32',
    step5: '32',
  };

  return stepWiseDiscount[`step${step}`];
};

export const generateStepWisePlan = (
  min: number,
  max: number,
  slabCount: number,
) => {
  const stepWiseMap: Record<string, number | string> = {};
  let index = 1;
  for (let i = min; i <= max; i += slabCount) {
    stepWiseMap[`step${index}`] = i;
    // eslint-disable-next-line no-plusplus
    index++;
  }
  stepWiseMap[`step${index}`] = `${max}+`;
  return stepWiseMap;
};

export const getPlansIcon = (planName) => {
  const planIconMap = {
    [SubscriptionPlanTitle.OutreachBasicMonthly]: Images.RocketColor,
    [SubscriptionPlanTitle.OutreachProMonthly]: Images.HeartColor,
    [SubscriptionPlanTitle.OutreachScaleMonthly]: Images.StarColor,
    [SubscriptionPlanTitle.OutreachScaleMonthly100k]: Images.BuildingColor,
    [SubscriptionPlanTitle.OutreachScaleMonthly200k]: Images.BuildingColor,
    [SubscriptionPlanTitle.OutreachScaleMonthly300k]: Images.BuildingColor,
    [SubscriptionPlanTitle.OutreachScaleMonthly400k]: Images.BuildingColor,
    [SubscriptionPlanTitle.OutreachScaleMonthly500k]: Images.BuildingColor,
    [SubscriptionPlanTitle.OutreachBasicQuarterly]: Images.RocketColor,
    [SubscriptionPlanTitle.OutreachProQuarterly]: Images.HeartColor,
    [SubscriptionPlanTitle.OutreachScaleQuarterly]: Images.StarColor,
    [SubscriptionPlanTitle.OutreachScaleQuarterly100k]: Images.BuildingColor,
    [SubscriptionPlanTitle.OutreachScaleQuarterly200k]: Images.BuildingColor,
    [SubscriptionPlanTitle.OutreachScaleQuarterly300k]: Images.BuildingColor,
    [SubscriptionPlanTitle.OutreachScaleQuarterly400k]: Images.BuildingColor,
    [SubscriptionPlanTitle.OutreachScaleQuarterly500k]: Images.BuildingColor,
    [SubscriptionPlanTitle.OutreachBasicYearly]: Images.RocketColor,
    [SubscriptionPlanTitle.OutreachProYearly]: Images.HeartColor,
    [SubscriptionPlanTitle.OutreachScaleYearly]: Images.StarColor,
    [SubscriptionPlanTitle.OutreachScaleYearly100k]: Images.BuildingColor,
    [SubscriptionPlanTitle.OutreachScaleYearly200k]: Images.BuildingColor,
    [SubscriptionPlanTitle.OutreachScaleYearly300k]: Images.BuildingColor,
    [SubscriptionPlanTitle.OutreachScaleYearly400k]: Images.BuildingColor,
    [SubscriptionPlanTitle.OutreachScaleYearly500k]: Images.BuildingColor,
    [SubscriptionPlanTitle.Custom]: Images.BuildingColor,
    [SubscriptionPlanTitle.OutreachScaleMonthlyBase]: Images.BuildingColor,
    [SubscriptionPlanTitle.OutreachScaleQuarterlyBase]: Images.BuildingColor,
    [SubscriptionPlanTitle.OutreachScaleYearlyBase]: Images.BuildingColor,
  };

  return planIconMap[planName];
};

export const getIsFestiveDiscountActive = () => {
  if (process.env.REACT_APP_FDP_APPLICABLE === 'true') {
    return true;
  }
  return false;
};

export const getFestiveDiscountPercentage = () => {
  if (getIsFestiveDiscountActive() && process.env.REACT_APP_FDP_PERCENTAGE) {
    return parseFloat(process.env.REACT_APP_FDP_PERCENTAGE);
  }
  return 0;
};

export const getFestiveDiscountCouponCode = () => {
  if (getIsFestiveDiscountActive() && process.env.REACT_APP_FDP_PROMO_CODE) {
    return process.env.REACT_APP_FDP_PROMO_CODE;
  }
  return null;
};
